module.exports = __webpack_public_path__ + "img/instagram.faad5b09.svg";